import React from 'react';
import {Input, RemoveButton, RequiredButton} from '../../ui';
import {NumberIcon, SelectIcon} from '../../icons';
import {setFields} from '../../service/createForm.slice';
import {useRemoveField, useToggleRequired} from '../../model';
import {useDispatch} from 'react-redux';
import {useLocation} from 'react-router-dom';
import {useTranslation} from '../../../../hooks/useTranslation';
function NumericField({field, idx}) {
  const dispatch = useDispatch();
  const {removeField} = useRemoveField();
  const {toggleRequired} = useToggleRequired();
  const location = useLocation();
  let isReadOnly = Boolean(location.search.split('=')[1]);
  const {t} = useTranslation();
  const handleRequired = () => toggleRequired(idx);

  const handleChange = e => {
    dispatch(
      setFields({
        index: idx,
        key: 'label',
        value: e.target.value,
      }),
    );
  };

  const handleOptionLabel = (e, index) => {
    dispatch(
      setFields({
        parentIndex: idx,
        nestingKey: 'options',
        index,
        value: e.target.value,
        key: 'label',
      }),
    );
  };

  const handleAcceptableValue = (e, index) => {
    dispatch(
      setFields({
        parentIndex: idx,
        nestingKey: 'acceptable',
        index,
        value: e.target.value,
        acceptable: true,
      }),
    );
  };

  const handleDecommissionedValue = e => {
    dispatch(
      setFields({
        parentIndex: idx,
        nestingKey: 'decommission_trigger_value',
        value: e.target.value,
      }),
    );
  };

  const handleRemove = () => removeField(idx);
  return (
    <div className='f-build__general'>
      <div className='f-build__general-header'>
        <Input
          onChange={handleChange}
          label={t('createNewForm.components.fieldName')}
          placeholder={t('createNewForm.components.enterFieldName')}
          value={field?.label}
          disabled={isReadOnly}
        />
        {!isReadOnly && (
          <div className='f-build__general-actions'>
            <RequiredButton
              key={'input-required'}
              idx={idx}
              id={'input-required'}
              required={field?.required}
              handleRequired={handleRequired}
            />
            <RemoveButton
              key={'radio-remove'}
              idx={idx}
              id={'radio'}
              handleRemove={handleRemove}
            />
          </div>
        )}
      </div>
      <div className='f-build__general-type'>
        <NumberIcon />
        <span>{t('createNewForm.components.numeric')}</span>
      </div>
      <div className='f-build__general-acceptable'>
        <Input
          disabled={isReadOnly}
          value={field?.acceptable[0]}
          label={t('createNewForm.components.acceptable')}
          placeholder={`${t('createNewForm.components.firstNumber')}`}
          onChange={e => handleAcceptableValue(e, 0)}
        />
        <Input
          disabled={isReadOnly}
          value={field?.acceptable[1]}
          placeholder={`${t('createNewForm.components.secondNumber')}`}
          onChange={e => handleAcceptableValue(e, 1)}
        />
      </div>
      <div className='f-build__general-acceptable'>
        <Input
          disabled={isReadOnly}
          value={field?.decommission_trigger_value}
          label={t('createNewForm.components.decommissionTriggerValue')}
          placeholder={`Decommission trigger value`}
          onChange={handleDecommissionedValue}
        />
      </div>
    </div>
  );
}

export default NumericField;
